<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 24 35"
    role="presentation"
    xmlns="http://www.w3.org/2000/svg"
  >
	<path d="M11.9177941,-1.0658141e-14 C18.4991101,-1.0658141e-14 23.8352693,5.33379598 23.8352693,11.9133025 C23.8352693,16.0756629 20.2584569,23.4398018 13.1048321,34.0057191 L12.744194,34.5366994 C12.433178,34.9931039 11.8110608,35.1109646 11.3546562,34.7999487 C11.2512058,34.7294526 11.1619114,34.6401593 11.091414,34.5367098 C3.69713801,23.6861748 5.86197757e-14,16.1450391 5.86197757e-14,11.9133025 C5.86197757e-14,5.33379598 5.33552141,-1.0658141e-14 11.9177941,-1.0658141e-14 Z M11.9177144,5.95681063 C8.62657802,5.95681063 5.95881732,8.62370862 5.95881732,11.9134619 C5.95881732,15.2033745 8.62657802,17.8704319 11.9177144,17.8704319 C15.2083724,17.8704319 17.876452,15.2033745 17.876452,11.9134619 C17.876452,8.62370862 15.2083724,5.95681063 11.9177144,5.95681063 Z" :fill="fill"></path>
  </svg>
</template>

<script>
export default {
  props: {
		type: {
			type: String,
			ddefault: ''
		},
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 35,
    },
    fill: {
      type: String,
      default: "#000",
    },
  },
};
</script>

<style scoped>
path {
	transition: all .3s;
}
</style>
